<template>
  <div class="modal-div">
    <Form
      label-position="right"
      :model="formData"
      :label-width="160"
      :rules="rulesFrom"
      ref="formData"
      :disabled="formData.disabled"
      class="modal-form"
      :style="!formData.disabled ? 'height:clac(100% - 40px)' : 'height:100%'"
    >
      <Card v-if="!isBank" dis-hover style="margin-bottom: 20px">
        <div slot="title">
          {{ $t("accountInformation") }}
        </div>
        <Row :gutter="10">
          <Col span="6">
            <FormItem :label="$t('account')" prop="account">
              <Input
                v-model="formData.account"
                :placeholder="$t('enter') + $t('account')"
                :disabled="formData.id ? true : false"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6" v-if="formData.id">
            <FormItem :label="$tz('手机号码')" prop="account_phone">
              <Input v-model="formData.account_phone" disabled></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('contract_title')" prop="main_contract_header">
              <Select
                v-model="formData.main_contract_header"
                filterable
                clearable
                :placeholder="$t('select') + $t('contract_title')"
                :filter-by-label="true"
                :class="editObj.main_contract_header ? 'is-edit' : ''"
              >
                <Option
                  v-for="item in selectData['c_title']"
                  :value="item.id"
                  :key="item.id"
                  :label="item.title"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('spare_contract_header')">
              <Select
                v-model="formData.spare_contract_header"
                filterable
                clearable
                :placeholder="$t('select') + $t('spare_contract_header')"
                :filter-by-label="true"
                :class="editObj.spare_contract_header ? 'is-edit' : ''"
                @on-change="changeClear('spare_contract_header', $event)"
              >
                <Option
                  v-for="item in selectData['c_title']"
                  :value="item.id"
                  :key="item.id"
                  :label="item.title"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6" v-if="formData.text != 'add'">
            <FormItem :label="$t('status')" prop="status">
              <RadioGroup v-model="formData.status">
                <Radio
                  :label="item.value"
                  v-for="item in selectData['status']"
                  :key="item.lable"
                  :class="editObj.status ? 'is-edit' : ''"
                  border
                >
                  {{ item.label }}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('special_remark')">
              <Input
                v-model="formData.special_remarks"
                :placeholder="$t('enter') + $t('special_remark')"
                :disabled="formData.id ? true : false"
                :class="editObj.special_remarks ? 'is-edit' : ''"
              >
              </Input>
            </FormItem>
          </Col>
        </Row>
      </Card>
      <Card v-if="!isBank" dis-hover style="margin-bottom: 20px">
        <div slot="title">
          {{ $t("clientInformation") }}
        </div>
        <Row :gutter="10">
          <Col span="6">
            <FormItem :label="$t('clientCompany')" prop="shipper_platform">
              <Select
                v-model="formData.shipper_platform"
                filterable
                :placeholder="$t('select') + $t('clientCompany')"
                :class="editObj.shipper_platform ? 'is-edit' : ''"
              >
                <Option v-for="item in shipperList" :value="item" :key="item">{{
                  item
                }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('clientCompany') + 'ID'">
              <Input
                v-model="formData.platform_id"
                :placeholder="$t('select') + $t('clientCompany') + 'ID'"
                :class="editObj.platform_id ? 'is-edit' : ''"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('delivery_mode')" prop="delivery_mode">
              <Select
                v-model="formData.delivery_mode"
                filterable
                :placeholder="$t('select') + $t('delivery_mode')"
                :class="editObj.delivery_mode ? 'is-edit' : ''"
              >
                <Option v-for="item in modeList" :value="item" :key="item">{{
                  item
                }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('shipper_company')">
              <Input
                v-model="formData.shipper_company"
                :class="editObj.shipper_company ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('shipper_company')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem
              :label="$t('company_t') + '/' + $t('personal_cn')"
              prop="shipper_company_cn"
            >
              <Input
                v-model="formData.shipper_company_cn"
                :class="editObj.shipper_company_cn ? 'is-edit' : ''"
                :placeholder="
                  $t('enter') + $t('company_t') + '/' + $t('personal_cn')
                "
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem
              :label="$tz('公司,/,个人中文名,简称')"
              prop="short_company_name_cn"
            >
              <Input
                v-model="formData.short_company_name_cn"
                :class="editObj.short_company_name_cn ? 'is-edit' : ''"
                :placeholder="$tz('请输入,公司,/,个人中文名,简称')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem
              :label="
                $t('company_t') + '/' + $t('personal_en') + $t('fullName')
              "
              prop="shipper_company_en"
            >
              <Input
                v-model="formData.shipper_company_en"
                :class="editObj.shipper_company_en ? 'is-edit' : ''"
                :placeholder="
                  $t('enter') +
                    $t('company_t') +
                    '/' +
                    $t('personal_en') +
                    $t('fullName')
                "
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('shipperCode')" prop="shipper_name">
              <Input
                v-model="formData.shipper_name"
                :class="editObj.shipper_name ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('shipperCode')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('ownership')" prop="ownership">
              <Select
                v-model="formData.ownership"
                filterable
                :placeholder="$t('select') + $t('ownership')"
                :filter-by-label="true"
                :class="editObj.ownership ? 'is-edit' : ''"
              >
                <Option
                  v-for="item in selectData['ownership']"
                  :value="item.id"
                  :key="item.id"
                  :label="item.title"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('shipper_telephone')" prop="shipper_telephone">
              <Input
                v-model="formData.shipper_telephone"
                :class="editObj.shipper_telephone ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('shipper_telephone')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('shipper_mobile')" prop="shipper_mobile">
              <Input
                v-model="formData.shipper_mobile"
                :class="editObj.shipper_mobile ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('shipper_mobile')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('shipperAddress')" prop="shipper_address1">
              <Input
                v-model="formData.shipper_address1"
                type="textarea"
                :class="editObj.shipper_address1 ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('shipperAddress')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('Address2')" prop="shipper_address2">
              <Input
                type="textarea"
                v-model="formData.shipper_address2"
                :class="editObj.shipper_address2 ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('Address2')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('contactEmail')" prop="service_email">
              <Input
                v-model="formData.service_email"
                :class="editObj.service_email ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('contactEmail')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('financeEmail')" prop="bill_email">
              <Input
                v-model="formData.bill_email"
                :class="editObj.bill_email ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('financeEmail')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('qq') + '/' + $t('wechat')">
              <Input
                v-model="formData.qq"
                :class="editObj.qq ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('qq') + '/' + $t('wechat')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('error_value')">
              <Input
                v-model="formData.error_value"
                :class="editObj.error_value ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('error_value')"
              >
                <span slot="append">KG</span>
              </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('group_name1')">
              <Input
                v-model="formData.group_name"
                :class="editObj.group_name ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('group_name1')"
              >
              </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('taxationType')" prop="price_type">
              <RadioGroup v-model="formData.dd_type">
                <Radio
                  label="DDP"
                  border
                  :class="editObj.dd_type ? 'is-edit' : ''"
                >
                  DDP
                </Radio>
                <Radio
                  label="DDU"
                  border
                  :class="editObj.dd_type ? 'is-edit' : ''"
                >
                  DDU
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('individual traveler')">
              <RadioGroup v-model="formData.fit">
                <Radio :label="1" border :class="editObj.fit ? 'is-edit' : ''">
                  {{ $t("YES") }}
                </Radio>
                <Radio :label="0" border :class="editObj.fit ? 'is-edit' : ''">
                  {{ $t("NO") }}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$tz('重量误差')">
              <RadioGroup v-model="formData.is_error_value">
                <Radio
                  :label="1"
                  border
                  :class="editObj.is_error_value ? 'is-edit' : ''"
                >
                  {{ $tz("启用") }}
                </Radio>
                <Radio
                  :label="0"
                  border
                  :class="editObj.is_error_value ? 'is-edit' : ''"
                >
                  {{ $tz("禁用") }}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$tz('系统通知手机')" prop="system_phone">
              <Input
                v-model="formData.system_phone"
                :placeholder="$tz('请输入,系统通知手机')"
              >
              </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$tz('系统通知邮箱')" prop="system_email">
              <Input
                v-model="formData.system_email"
                :placeholder="$tz('请输入,系统通知邮箱')"
              >
              </Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('refund_address')">
              <Input
                v-model="formData.refund_address"
                :placeholder="$t('enter') + $t('refund_address')"
              >
              </Input>
            </FormItem>
          </Col>
        </Row>
      </Card>
      <Card
        dis-hover
        style="margin-bottom: 20px"
        v-for="(item, index) in formData.bank"
        :key="item.location"
      >
        <div slot="title">
          {{ $t("cod_money_back") + $t("bank_accounts") }}({{
            item.location == "PRC" ? "CNY" : "USD"
          }})
        </div>

        <Row :gutter="10">
          <Col span="6">
            <FormItem :label="$t('area')">
              <RadioGroup v-model="item.location" style="height: 32px">
                <Radio :label="item.location" border>
                  {{
                    item.location == "PRC"
                      ? $t("china") + $t("mainland")
                      : $t("china") + $t("hongkong")
                  }}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('bank_accounts')">
              <Input
                v-model="item.bank_account_number"
                filterable
                :placeholder="$t('enter') + $t('bank_accounts')"
              >
              </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('account_name')">
              <Input
                v-model="item.account_name"
                filterable
                :placeholder="$t('enter') + $t('account_name')"
              >
              </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('bank_account')">
              <Input
                v-model="item.bank_name"
                filterable
                :placeholder="$t('enter') + $t('bankDetails')"
              >
              </Input>
            </FormItem>
          </Col>
          <template v-if="item.location != 'PRC'">
            <Col span="6">
              <FormItem :label="$t('bank_address')">
                <Input
                  v-model="item.bank_address"
                  filterable
                  :placeholder="$t('enter') + $t('bank_address')"
                >
                </Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="Bank Code">
                <Input
                  v-model="item.bank_code"
                  filterable
                  :placeholder="$t('enter') + 'Bank Code'"
                >
                </Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="Swift Code">
                <Input
                  v-model="item.swift_code"
                  filterable
                  :placeholder="$t('enter') + 'Swift Code'"
                >
                </Input>
              </FormItem>
            </Col>
          </template>
          <Col span="6">
            <FormItem :label="$tz('默认回款')">
              <RadioGroup v-model="item.is_selected" style="height: 32px">
                <Radio
                  :label="1"
                  border
                  :disabled="!!formData.bank[index == 1 ? 0 : 1].is_selected"
                >
                  {{ $tz("是") }}
                </Radio>
                <Radio
                  :label="0"
                  border
                  :disabled="!!formData.bank[index == 1 ? 0 : 1].is_selected"
                >
                  {{ $tz("否") }}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
      </Card>
      <Card v-if="!isBank" dis-hover style="margin-bottom: 20px">
        <div slot="title">
          {{ $t("alipay") }}
        </div>
        <Row :gutter="10">
          <Col span="6">
            <FormItem :label="$t('account_name')">
              <Input
                v-model="formData.alipay_account"
                :class="editObj.alipay_account ? 'is-edit' : ''"
                filterable
                :placeholder="$t('enter') + $t('account_name')"
              >
              </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('alipay_name')">
              <Input
                v-model="formData.alipay_name"
                :class="editObj.alipay_name ? 'is-edit' : ''"
                filterable
                :placeholder="$t('enter') + $t('alipay_name')"
              >
              </Input>
            </FormItem>
          </Col>
        </Row>
      </Card>
      <Card v-if="!isBank" dis-hover style="margin-bottom: 20px">
        <div slot="title">
          {{ $t("relatedPersonnel") }}
        </div>
        <Row :gutter="10">
          <Col span="8">
            <FormItem
              :label-width="220"
              :label="$t('salesman')"
              prop="salesman_id"
            >
              <Select
                v-model="formData.salesman_id"
                :class="editObj.salesman_id ? 'is-edit' : ''"
                filterable
                :placeholder="$t('select') + $t('salesman')"
              >
                <Option
                  v-for="item in selectData['salesmanId']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem
              :label-width="220"
              :label="$t('Finance of Guangzhou Hq (Freight: small bag)')"
              prop="accounting_id"
            >
              <Select
                v-model="formData.accounting_id"
                :class="editObj.accounting_id ? 'is-edit' : ''"
                filterable
                :placeholder="
                  $t('select') +
                    $t('Finance of Guangzhou Hq (Freight: small bag)')
                "
              >
                <Option
                  v-for="item in selectData['accountingList']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem
              :label-width="220"
              :label="$t('Finance of Guangzhou Hq (Freight: Shuangqing)')"
              prop="dbl_finance"
            >
              <Select
                v-model="formData.dbl_finance"
                :class="editObj.dbl_finance ? 'is-edit' : ''"
                filterable
                :placeholder="
                  $t('select') +
                    $t('Finance of Guangzhou Hq (Freight: Shuangqing)')
                "
              >
                <Option
                  v-for="item in selectData['accountingList']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem
              :label-width="220"
              :label="$t('Finance of Guangzhou Hq (COD)')"
              prop="cod_finance"
            >
              <Select
                v-model="formData.cod_finance"
                :class="editObj.cod_finance ? 'is-edit' : ''"
                filterable
                :placeholder="
                  $t('select') + $t('Finance of Guangzhou Hq (COD)')
                "
              >
                <Option
                  v-for="item in selectData['accountingList']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem
              :label-width="220"
              :label="$t('Branch financial supervisor')"
              prop="branch_accounting_id"
            >
              <Select
                v-model="formData.branch_accounting_id"
                :class="editObj.branch_accounting_id ? 'is-edit' : ''"
                filterable
                :placeholder="$t('select') + $t('Branch financial supervisor')"
              >
                <Option
                  v-for="item in selectData['branch_finance']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem
              :label-width="220"
              :label="$t('Branch financial accountant')"
              prop="branch_op_accounting_id"
            >
              <Select
                v-model="formData.branch_op_accounting_id"
                :class="editObj.branch_op_accounting_id ? 'is-edit' : ''"
                filterable
                :placeholder="$t('select') + $t('Branch financial supervisor')"
              >
                <Option
                  v-for="item in selectData['branch_finance']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label-width="220" :label="$t('serviceName')">
              <Select
                v-model="formData.customer_service_id"
                :class="editObj.customer_service_id ? 'is-edit' : ''"
                filterable
                :placeholder="$t('select') + $t('serviceName')"
                clearable
                @on-change="changeClear('customer_service_id', $event)"
              >
                <Option
                  v-for="item in selectData['customerServiceId']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label-width="220" :label="$tz('沙特,B2B客服')">
              <Select
                v-model="formData.dbl_customer_service_id"
                :class="editObj.dbl_customer_service_id ? 'is-edit' : ''"
                filterable
                :placeholder="$t('select') + $t('delService')"
                clearable
                @on-change="changeClear('dbl_customer_service_id', $event)"
              >
                <Option
                  v-for="item in selectData['dblServiceList']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label-width="220" :label="$tz('非沙特,B2B客服')">
              <Select
                v-model="formData.branch_dbl_customer_service_id"
                :class="editObj.branch_dbl_customer_service_id ? 'is-edit' : ''"
                filterable
                :placeholder="$t('select') + $t('delService')"
                clearable
                @on-change="
                  changeClear('branch_dbl_customer_service_id', $event)
                "
              >
                <Option
                  v-for="item in selectData['dblServiceList']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem
              :label-width="220"
              :label="$t('operation') + $t('service')"
            >
              <Select
                v-model="formData.op_customer_service_id"
                :class="editObj.op_customer_service_id ? 'is-edit' : ''"
                filterable
                :placeholder="$t('select') + $t('operation') + $t('service')"
                clearable
                @on-change="changeClear('op_customer_service_id', $event)"
              >
                <Option
                  v-for="item in selectData['operateList']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem
              :label-width="220"
              :label="$t('branchOffice') + $t('service')"
            >
              <Select
                v-model="formData.branch_customer_service_id"
                :class="editObj.branch_customer_service_id ? 'is-edit' : ''"
                filterable
                :placeholder="$t('select') + $t('branchOffice') + $t('service')"
                clearable
                @on-change="changeClear('branch_customer_service_id', $event)"
              >
                <Option
                  v-for="item in selectData['branchServiceList']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Card>
      <Card v-if="!isBank" dis-hover style="margin-bottom: 20px">
        <div slot="title">
          {{ $t("relatedOther") }}
        </div>
        <Row :gutter="10">
          <Col span="6">
            <FormItem :label="$t('period')" prop="billing_cycle">
              <Select
                v-model="formData.billing_cycle"
                :class="editObj.billing_cycle ? 'is-edit' : ''"
                filterable
                :placeholder="$t('select') + $t('period')"
              >
                <Option
                  v-for="item in selectData['chargePeriod']"
                  :value="item.value"
                  :key="item.value"
                  :label="item.label"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('credit_limit')" prop="credit_limit">
              <Input
                v-model="formData.credit_limit"
                :class="editObj.credit_limit ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('credit_limit')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$tz('额度,币种')" prop="credit_limit_currency">
              <Select
                v-model="formData.credit_limit_currency"
                :class="editObj.credit_limit_currency ? 'is-edit' : ''"
                filterable
                :placeholder="$tz('额度,币种')"
              >
                <Option
                  v-for="item in selectData['currency']"
                  :value="item.code"
                  :key="item.code"
                  :label="item.title"
                ></Option>
              </Select>
            </FormItem>
          </Col>
          <!-- <Col span="6">
            <FormItem :label="$t('ddx')" prop="ddx">
              <RadioGroup v-model="formData.ddx">
                <Radio label="DDP" border>
                  DDP
                </Radio>
                <Radio label="DDU" border>
                  DDU
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col> -->
          <Col span="6">
            <FormItem :label="$t('customer_report')">
              <RadioGroup v-model="formData.customer_report">
                <Radio
                  label="yes"
                  border
                  :class="editObj.customer_report ? 'is-edit' : ''"
                >
                  {{ $t("YES") }}
                </Radio>
                <Radio
                  label="no"
                  border
                  :class="editObj.customer_report ? 'is-edit' : ''"
                >
                  {{ $t("NO") }}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('b2b_prefix')">
              <Input
                v-model="formData.b2b_prefix"
                :class="editObj.b2b_prefix ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('b2b_prefix')"
                minlength="4"
                maxlength="6"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="6">
            <FormItem :label="$t('spc_way_weight')" prop="spc_way_weight">
              <RadioGroup v-model="formData.spc_way_weight">
                <Radio
                  :label="1"
                  border
                  :class="editObj.spc_way_weight ? 'is-edit' : ''"
                >
                  {{ $t("YES") }}
                </Radio>
                <Radio
                  :label="0"
                  border
                  :class="editObj.spc_way_weight ? 'is-edit' : ''"
                >
                  {{ $t("NO") }}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('is_hedge')" prop="is_hedge">
              <RadioGroup @on-change="hedgeChange" v-model="formData.is_hedge">
                <Radio
                  label="YES"
                  border
                  :class="editObj.is_hedge ? 'is-edit' : ''"
                >
                  {{ $t("YES") }}
                </Radio>
                <Radio
                  label="NO"
                  border
                  :class="editObj.is_hedge ? 'is-edit' : ''"
                >
                  {{ $t("NO") }}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem
              v-if="formData.is_hedge == 'YES'"
              :label="$t('hedge_amount')"
              prop="hedge_amount"
            >
              <Input
                v-model="formData.hedge_amount"
                :class="editObj.hedge_amount ? 'is-edit' : ''"
                :placeholder="$t('select') + $t('hedge_amount')"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label="$t('takenMode')" prop="price_type">
              <RadioGroup
                @on-change="hedgeChange"
                v-model="formData.price_type"
              >
                <Radio
                  :label="1"
                  border
                  :class="editObj.price_type ? 'is-edit' : ''"
                >
                  {{ $t("fullPrice") }}
                </Radio>
                <Radio
                  :label="2"
                  border
                  :class="editObj.price_type ? 'is-edit' : ''"
                >
                  {{ $t("halfPrice") }}
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="10">
          <Col span="12">
            <FormItem :label="$t('salesman_remarks')">
              <Input
                type="textarea"
                v-model="formData.remarks"
                :class="editObj.remarks ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('salesman_remarks')"
                :rows="3"
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('manager_remarks')">
              <Input
                type="textarea"
                v-model="formData.manager_remarks"
                :class="editObj.manager_remarks ? 'is-edit' : ''"
                :placeholder="$t('enter') + $t('manager_remarks')"
                :rows="3"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </Card>
    </Form>
    <div
      class="footer-btn"
      v-if="!formData.disabled"
      style="padding: 12px 18px 12px 18px; margin: 0 -16px"
    >
      <Button type="text" @click="close" style="margin-right: 8px">
        {{ $t("cancel") }}
      </Button>
      <Button type="primary" @click="save">
        {{ $t("confirm") }}
      </Button>
    </div>
  </div>
</template>

<script>
import {
  add,
  update,
  getCompanies,
  getPlatform,
  getDeliverType,
  saveUserFinanceInfo
} from "@/api/user/client";
// import { getUser, getOperateService } from "@/api/user/internal";
// import { getContractParams } from "@/api/user/contract";
export default {
  inject: ["$page"],
  props: {
    row: {
      type: Object,
    },
    close: {
      type: Function
    },
    selectData: {
      type: Object
    },
    isBank: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        price_type: 1,
        dd_type: "DDP",
        is_error_value: 0,
        credit_limit_currency: "CNY",
        fit: 0,
        bank: [{ is_selected: 0 }, { is_selected: 0 }]
      },
      preForm: {},
      rulesFrom: {
        main_contract_header: [
          {
            required: true,
            message: this.$t("select") + this.$t("contract_title"),
            type: "number",
            trigger: "change"
          }
        ],
        account: [
          {
            required: true,
            message: this.$t("enter") + this.$t("account"),
            trigger: "blur"
          }
        ],
        shipper_platform: [
          {
            required: true,
            message: this.$t("select") + this.$t("clientCompany"),
            trigger: "change"
          }
        ],
        delivery_mode: [
          {
            required: true,
            message: this.$t("select") + this.$t("delivery_mode"),
            trigger: "change"
          }
        ],
        shipper_company_cn: [
          {
            required: true,
            message:
              this.$t("enter") +
              this.$t("company_t") +
              "/" +
              this.$t("personal_cn"),
            trigger: "blur"
          }
        ],
        shipper_company_en: [
          {
            required: true,
            message:
              this.$t("enter") +
              this.$t("company_t") +
              "/" +
              this.$t("personal_en") +
              this.$t("fullName"),
            trigger: "blur"
          }
        ],
        shipper_name: [
          {
            required: true,
            message: this.$t("enter") + this.$t("shipperCode"),
            trigger: "blur"
          }
        ],
        shipper_address1: [
          {
            required: true,
            message: this.$t("enter") + this.$t("shipperAddress"),
            trigger: "blur"
          }
        ],
        system_phone: [
          {
            required: true,
            message: this.$t("enter") + this.$t("system_phone"),
            trigger: "blur"
          }
        ],
        system_email: [
          {
            required: true,
            message: this.$t("enter") + this.$t("system_email"),
            trigger: "blur"
          }
        ],
        shipper_address2: [
          {
            required: true,
            message: this.$t("enter") + this.$t("Address2"),
            trigger: "blur"
          }
        ],
        shipper_mobile: [
          {
            required: true,
            message: this.$t("enter") + this.$t("shipper_mobile"),
            trigger: "blur"
          }
        ],
        shipper_telephone: [
          {
            required: true,
            message: this.$t("enter") + this.$t("shipper_telephone"),
            trigger: "blur"
          }
        ],
        service_email: [
          {
            required: true,
            message: this.$t("enter") + this.$t("contactEmail"),
            trigger: "change"
          },
          {
            type: "email",
            message: this.$t("email_format"),
            trigger: "blur"
          }
        ],
        bill_email: [
          {
            required: true,
            message: this.$t("enter") + this.$t("financeEmail"),
            trigger: "change"
          },
          {
            type: "email",
            message: this.$t("email_format"),
            trigger: "blur"
          }
        ],
        // customer_service_id: [
        //   {
        //     required: true,
        //     type: "number",
        //     message: "customer_servicecannot be empty",
        //     trigger: "change"
        //   }
        // ],
        // dbl_customer_service_id: [
        //   {
        //     required: true,
        //     type: "number",
        //     message: "customer_servicecannot be empty",
        //     trigger: "change"
        //   }
        // ],
        salesman_id: [
          {
            required: true,
            type: "number",
            message: this.$t("select") + this.$t("salesman"),
            trigger: "change"
          }
        ],
        shipper_company: [
          {
            required: true,
            message: this.$t("select") + this.$t("shipper_company"),
            trigger: "blur"
          }
        ],
        accounting_id: [
          {
            required: true,
            type: "number",
            message: this.$t("select") + this.$t("accounting"),
            trigger: "change"
          }
        ],
        billing_cycle: [
          {
            required: true,
            message: this.$t("select") + this.$t("period"),
            trigger: "change"
          }
        ],
        // credit_limit: [
        //   {
        //     required: true,
        //     message: this.$t("select") + this.$t("credit_limit"),
        //     trigger: "blur"
        //   }
        // ],
        is_hedge: [
          {
            required: true,
            message: this.$t("select") + this.$t("is_hedge"),
            trigger: "change"
          }
        ],
        hedge_amount: [
          {
            required: true,
            message: this.$t("select") + this.$t("hedge_amount"),
            trigger: "blur"
          }
        ],
        balance_amount: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "blur"
          }
        ],
        account_balances: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "blur"
          }
        ],
        remarks: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "blur"
          }
        ],
        aliexpress_id: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "blur"
          }
        ],
        status: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        ownership: [
          {
            required: true,
            type: "number",
            message: this.$t("select") + this.$t("ownership"),
            trigger: "change"
          }
        ],
        spc_way_weight: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ]
      },
      shipperList: [],
      modeList: [],
      // serviceList: [],
      // accountingList: [],
      // salesmanList: [],
      // dblServiceList: [],
      // operateList: [],
      // companiesList: [],
      // titleList: [],
      unChange: true,
      editObj: {}
    };
  },
  // watch: {
  //   formData: {
  //     handler: function(nowVal) {
  //       var $this = this;
  //       for (let i in $this.formData) {
  //         if (JSON.stringify(nowVal[i]) !== JSON.stringify($this.preForm[i])) {
  //           $this.unChange = false;
  //           break;
  //         } else {
  //           $this.unChange = true;
  //         }
  //       }
  //     },
  //     deep: true
  //   },
  //   "formData.bank": {
  //     handler: function(nowVal) {
  //       var $this = this;
  //       for (let i in nowVal) {
  //         if (
  //           JSON.stringify(nowVal[i]) !== JSON.stringify($this.preForm.bank[i])
  //         ) {
  //           $this.unChange = false;
  //           break;
  //         } else {
  //           $this.unChange = true;
  //         }
  //       }
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    getOtherList() {
      // getUser({ standard: "CustomerService" }).then(res => {
      //   this.serviceList = res.data.payload.rows;
      // });
      // getUser({ standard: "Accounting" }).then(res => {
      //   this.accountingList = res.data.payload.rows;
      // });
      // getUser({ standard: "Salesman" }).then(res => {
      //   this.salesmanList = res.data.payload.rows;
      // });
      // getUser({ standard: "DblCustomerService" }).then(res => {
      //   this.dblServiceList = res.data.payload.rows;
      // });
      // getOperateService().then(res => {
      //   this.operateList = res.data.payload;
      // });
      getCompanies().then(res => {
        this.companiesList = res.data.payload;
      });
      getPlatform().then(res => {
        this.shipperList = res.data.payload;
      });
      getDeliverType().then(res => {
        this.modeList = res.data.payload;
      });
      // getContractParams().then(res => {
      //   this.titleList = res.data.payload.header;
      // });
    },
    hedgeChange() {
      this.$set(this.formData, "hedge_amount", "");
    },
    changeClear(key, val) {
      if (!val) {
        this.$set(this.formData, key, "");
      }
    },
    alertMes(res) {
      this.$Message[res.data.status ? "success" : "error"]({
        background: true,
        content: res.data.msg
      });
      if (res.data.status) {
        this.close();
        this.$page.getList();
      }
    },
    save() {
      this.$refs["formData"].validate(valid => {
        if (valid) {
          if (this.isBank) {
            saveUserFinanceInfo({
              id: this.formData.id,
              bank: this.formData.bank
            }).then(res => {
              this.alertMes(res);
            });
            return console.log(this.isBank, this.formData);
          }
          this.formData.status = !this.formData.id
            ? "DISABLE"
            : this.formData.status;
          if (this.formData.id) {
            update(this.formData).then(res => {
              this.alertMes(res);
            });
          } else {
            add(this.formData).then(res => {
              this.alertMes(res);
            });
          }
        } else {
          this.$Message["error"]({
            background: true,
            content: this.$t("form_data"),
            duration: 5
          });
        }
      });
    }
  },
  mounted() {
    this.formData = this.row;
    this.formData["price_type"] = this.formData["price_type"]
      ? this.formData["price_type"]
      : 1;
    this.formData["credit_limit_currency"] = this.formData[
      "credit_limit_currency"
    ]
      ? this.formData["credit_limit_currency"]
      : "CNY";
    this.formData["dd_type"] = this.formData["dd_type"]
      ? this.formData["dd_type"]
      : "DDP";
    this.formData["fit"] = this.formData["fit"] ? this.formData["fit"] : 0;
    this.formData["is_error_value"] = this.formData["is_error_value"]
      ? this.formData["is_error_value"]
      : 0;

    this.formData.spc_way_weight = this.row.spc_way_weight
      ? this.row.spc_way_weight
      : 0;
    this.editObj = this.row.edit ? this.row.edit : {};
    if (
      !this.formData.bank ||
      (this.formData.bank && this.formData.bank.length == 0)
    ) {
      this.formData.bank = [
        {
          location: "PRC",
          bank_account_number: "",
          account_name: "",
          bank_address: "",
          bank_code: "",
          swift_code: "",
          bank_name: "",
          is_selected: 0
        },
        {
          location: "HK",
          bank_account_number: "",
          account_name: "",
          bank_address: "",
          bank_code: "",
          swift_code: "",
          bank_name: "",
          is_selected: 0
        }
      ];
    }
    this.preForm = JSON.parse(JSON.stringify(this.row));
    this.getOtherList();
  }
};
</script>

<style scoped>
.ivu-card-body {
  padding-bottom: 0;
}
.modal-div {
  height: 650px;
}
.modal-form {
  height: calc(100% - 40px);
  overflow: auto;
}
.footer-btn {
  border-top: 1px solid #e8eaec;
  display: flex;
  justify-content: end;
}
.is-edit {
  border-radius: 4px;
  border: 1px solid red;
}
</style>
